import { Button } from '@mm/components';
import { landmineNames } from '@mm/constants/landmine-names';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import React from 'react';
import { useSelector } from 'react-redux';

type Props = {
  audienceId?: number;
  className?: string;
  disabled?: boolean;
  contactsCount?: number;
  processClick?: (callbackFb: (args?: any) => void) => void;
};

export const useExportContactsAction = () => {
  const canExportContacts = useSelector(
    combinedFeatureFlagsSelector,
  ).audiencesExportContacts;
  const { openContactsExportModal, openUniversalUpgradeLandmineModal } =
    useModalActions();

  return (
    audienceId?: number,
    contactsCount?: number,
    onSuccess?: () => void,
  ) => {
    if (!canExportContacts) {
      openUniversalUpgradeLandmineModal({
        landmineName: landmineNames['LEADS__CONTACTS__GET-CSV'],
        feature: 'audiencesExportContacts',
      });
      return;
    }
    if (audienceId) {
      openContactsExportModal(audienceId, contactsCount, onSuccess);
    } else {
      openContactsExportModal(null, contactsCount, onSuccess);
    }
  };
};

export const ExportContacts = ({
  audienceId,
  className,
  disabled,
  contactsCount,
  processClick = () => {},
}: Props) => {
  const exportContacts = useExportContactsAction();

  return (
    <Button
      css={{ container: className }}
      color="secondary"
      onClick={() =>
        processClick(() => exportContacts(audienceId, contactsCount))
      }
      disabled={disabled}
    >
      Export
    </Button>
  );
};
